<template>
  <div class="SelectBot">
    {{ label }}
    <select v-model="_value">
      <option :value="item.key" v-for="item in items" :key="item.key">{{item.label}}</option>
    </select>
  </div>
</template>

<script>
import Card from '@/components/atoms/Card'

export default {
  name: 'SelectBot',
  props: {
    value: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    label() {
      const item = this.items.find(item => item.key === this._value)
      return item ? item.label : '-'
    },
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped lang="scss">
.SelectBot {
  position: relative;
  overflow: hidden;
  padding: 9px;
  border: 1px solid $light;
  border-radius: $round;

  select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
  }
}
</style>
